import { Slider as AntSlider, type SliderSingleProps } from 'antd'

export type UiSliderProps = SliderSingleProps

export default function UiSlider(props: UiSliderProps) {
  return <AntSlider {...props} />
}
